<template>
  <div>

    <div class="app-title">
      <h2>负载平衡</h2>
    </div>

    <div class="app-content">
      <div class="card">
        <div class="d-flex flex-row bd-highlight mb-3 align-items-center" style="margin-left: 15px;margin-top: 15px">
          <b-form-input
                  id="entityModalSelect"
                  type="text"
                  plaintext
                  placeholder="请选择成本中心"
                  @click="entityModalSelectClick($event)"
                  v-model="currentCostCenterName"
                  class="form-control col-2"
          ></b-form-input>
          <el-tooltip effect="dark" content="开始时间" placement="top">
            <el-date-picker
                    style="margin-left: 20px;"
                    v-model="today"
                    type="date"
                    readonly
                    placeholder="开始日期">
            </el-date-picker>
          </el-tooltip>
          <i class="el-icon-minus"></i>
          <el-tooltip effect="dark" content="目标时间" placement="top">
            <el-date-picker
                    v-model="toDate"
                    align="right"
                    type="date"
                    placeholder="选择目标日期"
                    :disabled="loading"
                    :picker-options="pickerOptions_1"
                    @change="loadWorkCenters">
            </el-date-picker>
          </el-tooltip>
        </div>
      </div>

      <div class="card my-1">
        <div class="row">
          <div class="scroll">
            <div class="d-flex flex-row bd-highlight mb-3">
              <p class="text-center" v-if="workCenters.length===0">没有找到合适的工作中心</p>
              <div v-for="center in workCenters" :key="center.name"
                   style="width: min-content; margin-left: 5px; margin-top: 20px;">
                <div class="d-flex flex-column justify-content-center" @click="pickWorkCenter(center)">
                  <el-avatar :class="classArr[center.overFlow]" :size="50" :icon="iconArr[center.overFlow]"
                             fit="none"></el-avatar>
                  <span class="badge badge-pill badge-light center-name" data-toggle="tooltip"
                        :title="center.name">{{ center.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card my-1">
        <div id="schedule_view_chart" style="height: 600px"></div>
      </div>

    </div>
    <em-modal-normal-input-entity-selector ref="normalInputEntitySelector" entity="sithMesMstLocation"
                                           @entityModalSelectSelected="updateValue">
    </em-modal-normal-input-entity-selector>

    <el-dialog
            title="修改计划"
            :center="true"
            width="30%"
            :visible.sync="dialogVisible">
      <div class="col center-name dialog-text">
        <div class="row">
          当前工序
        </div>
        <div class="row">
          <div class="col" style="padding-left: 10%">
            <div class="row">
              成本中心：{{currentCostCenterName}}
            </div>
            <div class="row">
              工作中心：{{workCenters.length > 0 ? workCenters[dataIndex].name : ''}}
            </div>
            <div class="row">
              编号：{{opCode}}
            </div>
            <div class="row">
              计划完成日期：{{currentDate}}
            </div>
            <div class="row">
              计划工时：{{opHour}}H
            </div>
          </div>
        </div>
        <div class="row mt-2">
          移动至
        </div>
        <div class="row">
          <div class="col" style="padding-left: 10%">
            <div class="row">
              <el-select class="col mt-1" icon="el-icon-s-claim" v-model="targetWorkCenter" placeholder="目标工作中心">
                <el-option
                        v-for="(center,i) in workCenters"
                        :key="i"
                        :label="center.name"
                        :value="center.id">
                </el-option>
              </el-select>
            </div>
            <div class="row">
              <el-date-picker
                      class="col mt-1"
                      v-model="forecastDate"
                      type="date"
                      placeholder="目标计划日期"
                      :clearable="false"
                      :editable="false"
                      :picker-options="pickerOptions_2">
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submitChange">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
            title="选择工序"
            :center="true"
            :visible.sync="splitDialogVisible">
      <el-table
              :data="(workCenters.length > 0 && dataIndex > 0) ? workCenters[dataIndex].centerData[dateIndex].idList : []"
              style="width: 100%"
              @row-click="opSelect">
        <el-table-column
                prop="id"
                label="ID"
                width="180">
        </el-table-column>
        <el-table-column
                prop="code"
                label="编号"
                width="180">
        </el-table-column>
        <el-table-column
                prop="hour"
                label="工时">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="splitDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import EmCommonApi from "@/mixin/em/common/api";
  import moment from "moment";
  import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector";
  import {add, getOrDefault} from "../../LayoutMaps/maps/MapFunction";
  import * as echarts from 'echarts'

  export default {
    name: "Schedule",
    mixins: [EmCommonApi],
    components: {EmModalNormalInputEntitySelector},
    data() {
      return {
        currentCostCenter: '',
        currentCostCenterName: '',
        workCenters: [],//id,name,index,overFlow,centerData
        today: new Date(),
        toDate: new Date(),
        pickerOptions_1: {
          disabledDate(time) {
            return time.getTime() <= Date.now();
          },
          shortcuts: [{
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '两周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              picker.$emit('pick', date);
            }
          }, {
            text: '一月后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }]
        },
        chart: {},
        dataIndex: 0,
        chartData: [],
        loading: false,
        classArr: ['icon-success', 'icon-danger', 'icon-total'],
        iconArr: ['el-icon-s-claim', 'el-icon-s-release', 'el-icon-s-data'],

        dialogVisible: false,
        opId: '',
        opCode: '',
        opHour: '',
        currentDate: '',
        targetWorkCenter: '',
        targetWorkCenterName: '',
        forecastDate: '',
        pickerOptions_2: {
          disabledDate(time) {
            let date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return time.getTime() < date.getTime();
          }
        },
        splitDialogVisible: false,
        dateIndex: 0,

        submitLoading: false
      }
    },
    mounted() {
      this.toDate = this.getDaysLater(14)
      this.chart = echarts.init(document.getElementById('schedule_view_chart'));
      this.chartListener();
    },
    methods: {
      entityModalSelectClick() {
        this.$refs["normalInputEntitySelector"].showModal();
      },
      updateValue(selectRow) {
        console.log(selectRow)
        this.currentCostCenter = selectRow.id;
        this.currentCostCenterName = selectRow.name;
        this.loadWorkCenters();
      },
      getDaysLater(day_num) {
        let date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24 * day_num);
        return date
      },
      pickWorkCenter(info) {
        this.dataIndex = info.index
        this.loadChart()
      },
      loadWorkCenters() {
        this.chart.showLoading()
        this.loading = true
        let self = this
        const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesMstCalendarShift/getCalendarShiftOperation`
        this.$_emApiMixin_post(_api, {
              mstLocationId: this.currentCostCenter,
              fromDate: moment(new Date()).format(
                  this.$t("em.datetime.format.viewMode")
              ),
              toDate: moment(this.toDate).format(
                  this.$t("em.datetime.format.viewMode")
              )
            }
        ).then(request => {
          if (request.data.code === 0) {
            self.chart.hideLoading()
            self.loading = false;
            return
          }
          self.workCenters = [];
          self.chartData = [];
          let centerIndex = 0;
          for (let centerId in request.data.data) {//遍历工作中心
            let centerInfo = {
              id: centerId,
              name: request.data.data[centerId][0].workCenterName,
              index: centerIndex,
              overFlow: 0, //0:success,1:over
              centerData: []//工作中心对应信息
            }
            let data = [];
            let sum_workHour = 0;//工作中心共计时长
            let sum_baseHour = 0;
            centerIndex++
            data.push(['Time', 'BaseWorkHour', 'OP1', 'OP2', 'OP3', 'OP4', 'OP5', 'OP_ALL', 'OVER']);
            for (let dayItem of request.data.data[centerId]) {//遍历日期
              let dataItem = [];
              let baseHour = getOrDefault('baseWorkHour', dayItem, 0);
              let workHour = 0;//当天的总计划时常
              let merge = dayItem.operationList.length > 5;//工序超过5个则合并显示
              let rest_op = 5;
              let tooltipBuilder = [];//构建tooltip展示信息
              let op_list = [];
              dataItem.push(dayItem.dateStr);
              dataItem.push(baseHour);
              sum_baseHour += baseHour;
              tooltipBuilder.push('BaseHour: ' + baseHour + 'H')
              for (let op of dayItem.operationList) {//遍历每日工序
                let hour =
                    getOrDefault('workHour', op, 0) +
                    getOrDefault('bufferHour', op, 0) +
                    getOrDefault('transferHour', op, 0);
                workHour += hour;
                if (!merge) {
                  dataItem.push(hour);
                  rest_op--;
                }
                let op_code = getOrDefault('orderCode', op, '') + '-' + op.operationSeq
                op_list.push({
                  id: op.id,
                  code: op_code,
                  hour: hour
                });
                tooltipBuilder.push(op_code + ': ' + hour + 'H')
              }
              tooltipBuilder.push('Total: ' + workHour + 'H')
              centerInfo.centerData.push({
                dateStr: dayItem.dateStr,
                tooltipInfo: tooltipBuilder.join('<br/>'),
                idList: op_list
              })
              sum_workHour += workHour;
              while (rest_op > 0) {
                dataItem.push(0);
                rest_op--;
              }
              dataItem.push(merge ? workHour : 0);
              if (sum_workHour > sum_baseHour) {
                dataItem.push((sum_workHour - sum_baseHour).toFixed(1));
                centerInfo.overFlow = 1;//工作中心标红
              } else {
                dataItem.push(0);
              }
              data.push(dataItem);
            }
            self.workCenters.push(centerInfo)
            self.chartData.push(data);
          }
          self.calTotal()//计算统计数据
          self.loadChart()
          self.chart.hideLoading()
          self.loading = false;
        })
      },
      calTotal() {
        let tempCenters = [];
        tempCenters.push({
          id: 0,
          name: '总计',
          index: 0,
          overFlow: 2, //0:success,1:over,2:total
          centerData: []
        })
        for (let temp of this.workCenters) {
          temp.index++;
          tempCenters.push(temp)
        }
        this.workCenters = tempCenters;
        console.log(this.workCenters)
        let tempChartDataItem = [];
        tempChartDataItem.push(this.chartData[0][0])
        for (let i = 1; i < this.chartData[0].length; i++) {
          let dataItem = [];
          dataItem.push(this.chartData[0][i][0]);
          for (let j = 1; j < this.chartData[0][i].length; j++) {
            let sum = 0;
            for (let data of this.chartData) {
              sum = add(sum, data[i][j]);
            }
            dataItem.push(sum);
          }
          tempChartDataItem.push(dataItem);
        }
        let tempChartData = [];
        tempChartData.push(tempChartDataItem);
        for (let item of this.chartData) {
          tempChartData.push(item);
        }
        this.chartData = tempChartData;
        console.log(this.chartData)
      },
      loadChart() {
        let chart = this.chart
        let option = {
          color: ['#66cc99', '#6633cc', '#6666cc', '#6699cc', '#66cccc', '#66ffcc', '#6600cc'],
          title: {
            text: getOrDefault('name', this.workCenters[this.dataIndex], '')
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: (item) => {
              if (this.dataIndex === 0) {
                return null
              }
              return this.workCenters[this.dataIndex].centerData[item[0].dataIndex].tooltipInfo;
            }
          },
          dataset: {
            source: this.chartData[this.dataIndex]
          },
          xAxis: [{
            type: 'category'
          }],
          yAxis: [{
            type: 'value'
          }],
          dataZoom: [
            {
              type: 'slider',
              xAxisIndex: 0,
              start: 0,
              endValue: 20,
              minValueSpan: 4
            }, {
              type: 'inside',
              xAxisIndex: 0,
              start: 0,
              endValue: 20,
              minValueSpan: 4
            }
          ],
          series: [
            {
              name: 'BaseWorkHour',
              type: 'bar',
              barWidth: '15%'
            },
            {
              name: 'OP1',
              type: 'bar',
              stack: 'op'
            },
            {
              name: 'OP2',
              type: 'bar',
              stack: 'op'
            },
            {
              name: 'OP3',
              type: 'bar',
              stack: 'op'
            },
            {
              name: 'OP4',
              type: 'bar',
              stack: 'op'
            },
            {
              name: 'OP5',
              type: 'bar',
              stack: 'op'
            },
            {
              name: 'OP_ALL',
              type: 'bar',
              stack: 'op',
              label: {
                show: true,
                position: 'top',
                formatter: (item) => {
                  if (item.value[8] === 0) {
                    return '{success|√}'
                  } else {
                    return '{over|' + item.value[8] + 'h}'
                  }
                },
                rich: {
                  success: {
                    fontWeight: 'bold',
                    fontSize: 16,
                    color: '#28a745'

                  },
                  over: {
                    fontWeight: 'bold',
                    fontSize: 16,
                    color: '#dc3545'
                  }
                }
              }
            }
          ]
        }
        chart.setOption(option)
        window.onresize = function () {
          chart.resize()
        }
      },
      chartListener() {
        this.chart.on('dblclick', (item) => {
          if (item.seriesIndex === 0 || this.dataIndex === 0) {
            console.log('no reaction')
          } else {
            this.targetWorkCenter = this.workCenters[this.dataIndex].id;
            this.targetWorkCenterName = this.workCenters[this.dataIndex].name;
            this.currentDate = this.workCenters[this.dataIndex].centerData[item.dataIndex].dateStr;
            this.forecastDate = new Date(this.currentDate)
            if (item.seriesIndex === 6) {
              console.log('do split');
              this.dateIndex = item.dataIndex
              this.splitDialogVisible = true;
            } else {
              this.dialogVisible = true;
              let op = this.workCenters[this.dataIndex].centerData[item.dataIndex].idList[item.seriesIndex - 1];
              this.opId = op.id;
              this.opCode = op.code;
              this.opHour = op.hour
            }
          }
        })
      },
      opSelect(row) {
        this.splitDialogVisible = false
        this.opId = row.id
        this.opCode = row.code
        this.opHour = row.hour
        this.dialogVisible = true;
      },
      submitChange() {
        this.submitLoading = true;
        let today = moment(new Date(this.currentDate)).format(
            this.$t("em.date.format.viewMode")
        )
        let date = moment(this.forecastDate).format(
            this.$t("em.date.format.viewMode")
        )
        if (this.workCenters[this.dataIndex].id === this.targetWorkCenter && today === date) {
          this.$message({
            message: '没有改动！',
            type: 'warning'
          });
          this.submitLoading = false;
          return
        }
        let self = this;
        let _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesPrdPpOperation/manual-adjust`
        this.$_emApiMixin_post(_api, {
          operationId: this.opId,
          mstLocationId: this.targetWorkCenter,
          forecastFinishTime: moment(this.forecastDate).format(
              this.$t("em.datetime.format.viewMode")
          )
        }).then(request => {
          this.submitLoading = false;
          if (request.status === 200) {
            self.dialogVisible = false;
            self.$message({
              message: '修改成功！',
              type: 'success'
            });
            self.loadWorkCenters()
          } else {
            self.$message({
              message: '修改失败！',
              type: 'error'
            });
          }
        })
      }
    }
  }
</script>

<style scoped>
  .scroll {
    width: 100%;
    margin-left: 10px;
    margin-right: 10px;
    justify-content: space-between;
    white-space: nowrap;
    overflow-y: hidden;
    display: flex;
  }

  .center-name {
    width: 75px;
    margin-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dialog-text {
    width: 100% !important;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
  }

  .icon-success {
    margin: auto;
    color: #fff;
    background-color: #28a745;
    border-color: #28a745
  }

  .icon-success:hover {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34
  }

  .icon-success:active {
    box-shadow: 0 0 0 .2rem rgba(72, 180, 97, .5)
  }

  .icon-danger {
    margin: auto;
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545
  }

  .icon-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130
  }

  .icon-danger:active {
    box-shadow: 0 0 0 .2rem rgba(225, 83, 97, .5)
  }

  .icon-total {
    margin: auto;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
  }

  .icon-total:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }

  .icon-total:active {
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
  }

</style>